/**
 * Desktop - Header organism
 */

// Imports
import {
  siteId,
  headerId,
  navId,
  overlayClass,
  stickyClass,
  init as initialInit,
  getHeader,
  getInitialHeight,
  setInitialHeight,
  addOverlay as initialAddOverlay,
} from '../../common/organism/header';
import * as megadropdown from '../molecule/nav--main-drop-down';
import * as search from '../molecule/search';
import * as cartItems from '../molecule/cart-items';
import * as rewardNotifications from '../organism/reward-notifications';
import * as cart from '../Cart';
import * as Utils from '../../common/Utils';

// Constants (classes)
const miniClass = 'o-header--mini';

// Constants (functional)
const openingThreshold = 60;
const closingThreshold = 60;

/**
 * Reference to the header element.
 * @type {Object}
 */
let header = {};

/**
 * Last saved top position of the window.
 * @type {Number}
 */
let scrollTop = 0;

function saveInitialHeight() {
  if (!header.length) {
    return;
  }

  // Set overflow to hidden
  header.css('overflow', 'hidden');

  setInitialHeight(header.height());

  // Reset overflow
  header.css('overflow', 'visible');
}

/**
 * Whether you may not do spacing for header.
 * @return {Boolean} Defaults to true
 */
function doHeaderSpace() {
  if (Utils.isSiteLightview()) {
    return false;
  }
  return true;
}

function setSitePosition() {
  const site = $(`#${siteId}`);

  if (!site.length || !header.length || !doHeaderSpace()) {
    return;
  }

  site.css('padding-top', (header.hasClass(overlayClass) || header.hasClass(stickyClass)) ? getInitialHeight() : 0);
}

function addOverlay() {
  // Check if the main menu exists
  if (!$(`#${navId}`).length) {
    return;
  }

  initialAddOverlay();

  setSitePosition();
}

function addSticky() {
  header
    .addClass(stickyClass)
    .addClass(miniClass);

  setSitePosition();
}

function removeSticky() {
  header
    .removeClass(miniClass)
    .removeClass(stickyClass);

  setSitePosition();
}

function isMini() {
  return header.hasClass(miniClass);
}

function handleScroll() {
  // Check if the main menu exists
  if (!$(`#${navId}`).length) {
    return;
  }

  $(window).scroll(() => {
    const newScrollTop = $(document).scrollTop();

    if (newScrollTop < scrollTop) {
      // Handle up scroll

      if (newScrollTop <= closingThreshold) {
        // Closing threshold reached => back to normal display

        removeSticky();
      }
    } else if (newScrollTop > scrollTop) {
      // Handle down scroll

      if (newScrollTop > openingThreshold) {
        // Opening threshold reached => go sticky

        addSticky();
      }
    }

    // Save new top position
    scrollTop = newScrollTop;
  });
}

function init() {
  initialInit();

  // Get reference to the header element
  header = getHeader();

  // Save initial height
  saveInitialHeight();

  // Set overlay state
  addOverlay();

  // Handle the show/hide on scroll
  handleScroll();

  // Call init of the megadropdown
  megadropdown.init();

  if (!Utils.isAlgoliaOn()) {
    // Call init of the legacy search
    search.init();
  }

  // Call init of the cart
  cart.init();

  // Call init of the cart items
  cartItems.init();

  // Call init of the reward notifications
  rewardNotifications.init();
}

// Named exports - Constants
export {
  siteId,
  headerId,
  navId,
  overlayClass,
  stickyClass,
  miniClass,
};

// Named exports - Functions
export {
  init,
  setSitePosition,
  addSticky,
  removeSticky,
  isMini,
};

// Named exports - Modules
export {
  megadropdown,
  search,
  cartItems,
};



// WEBPACK FOOTER //
// ./js/desktop/organism/header.js